import React, { useContext } from "react";
import "./Talks.scss";
import TalkCard from "../../components/talkCard/TalkCard";
import { illustration, talkSection } from "../../portfolio";
import { Fade } from "react-reveal";
import StyleContext from "../../contexts/StyleContext";
import aboutSection from "../../assets/lottie/aboutme";
import DisplayLottie from "../../components/displayLottie/DisplayLottie";


export default function Talks() {
  const { isDark } = useContext(StyleContext);
  // if (!talkSection.display) {
  //   return null;
  // }
  return (
    <div className="main main-about" id="about">

      <div className="skills-main-div">
        <Fade left duration={1000}>
          <div className="skills-image-div skills-image-about">
            {illustration.animated ? (
              <DisplayLottie animationData={aboutSection} />
            ) : (
              <img
                alt="Man Working"
                src={require("../../assets/images/developerActivity.svg")}
              ></img>
            )}
          </div>
        </Fade>
        <Fade right duration={1000}>
          {/* <div> */}

          <div className="skills-text-div skills-about">
            <h1
              className={isDark ? "dark-mode skills-heading" : "skills-heading"}
            >
              {"About Me"}{" "}
            </h1>
            <p>
              I’m a Full Stack Developer with 3+ years of experience building scalable
              web applications using <strong>React.js, Node.js, MongoDB, and AWS</strong>.
            </p>

            <p>
              I’ve worked on end-to-end product development, including
              <strong>admin dashboards, payment integrations, and no-code platforms</strong>,
              with a strong focus on performance and clean architecture.
            </p>

            <p>
              Recently, I’ve expanded into <strong>AI-powered development</strong>,
              building features using
              <strong>OpenAI APIs, RAG, vector databases, and prompt engineering</strong>
              to create smarter user experiences.
            </p>

            <p>
              I enjoy solving real-world problems, optimizing applications, and building
              products that are both scalable and user-friendly.
            </p>          </div>
          {/* </div>  */}

        </Fade>
      </div>
    </div>

  );
}
